import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react';
import { PromotionConditionOperator } from '@app/common';

const columnHelper = createColumnHelper<PromotionConditionOperator>();

const getLabel = (operator: PromotionConditionOperator) => {
  switch (operator) {
    case PromotionConditionOperator.EQUAL:
      return "Égal à";
    case PromotionConditionOperator.NOT_EQUAL:
      return "Différent de";
    case PromotionConditionOperator.GREATER_THAN:
      return "Supérieur à";
    case PromotionConditionOperator.LESS_THAN:
      return "Inférieur à";
    case PromotionConditionOperator.GREATER_THAN_OR_EQUAL:
      return "Supérieur ou égal à";
    case PromotionConditionOperator.LESS_THAN_OR_EQUAL:
      return "Inférieur ou égal à";
    case PromotionConditionOperator.IN:
      return "Dans";
    case PromotionConditionOperator.NOT_IN:
      return "Pas dans";
  }
}

const columns = [
  columnHelper.display({
    id: 'operator',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Opérateur
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {getLabel(info.row.original)}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const OperatorSelect = ({ label = 'Opérateur', data, ...props }: Omit<SelectProps<any>, 'table'> & { data: PromotionConditionOperator[] }) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => item,
        value: (item) => item,
        display: (item) => getLabel(item)
      }}
      {...props} />
  );
};
